import React, { useRef, useState } from "react";
import { Map, GoogleApiWrapper, Marker, InfoWindow } from "google-maps-react";
import { useEffect } from "react";
import { GOOGLE_API } from "../../../Constant";

const mapStyles = {
  width: "100%",
  height: "100%",
  borderRadius: "20px",
};

const MapContainer = ({ markers, google }) => {
  const [state, setState] = useState({
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
  });
  const [bounds, setBounds] = useState([]);

  // var bounds = new props.google.maps.LatLngBounds();

  const onMarkerClick = (props, marker, e) => {
    setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  };

  const onClose = (props) => {
    if (state.showingInfoWindow) {
      setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };

  // const markersDefault = [
  //     {
  //         name: 'India',
  //         position: { lat: 21.7679, lng: 78.8718 }
  //     },
  //     {
  //         name: 'Nairobi National Park',
  //         position: { lat: -1.3733, lng: 36.8589 }
  //     },
  //     // ... other markers ...
  // ];

  const handleMapReady = (mapProps, map) => {
    map.setMapTypeId("satellite");

    // markers.forEach(marker => {
    //     bounds.extend(new mapProps.google.maps.LatLng(marker.lat, marker.lng));
    // });

    // map.fitBounds(bounds);
  };

  useEffect(() => {
    const bounds = new google.maps.LatLngBounds();
    markers.forEach((marker) => bounds.extend(marker.position));
    setBounds(bounds);
  }, [markers]);

  console.log(markers, "marksers");
  console.log(bounds, "bounds");

  // const initialCenter = markers.length > 0 ? markers?.[0]?.position : { lat: 20.5937, lng: 78.9629 };

  return (
    <Map
      google={google}
      // zoom={14}
      style={mapStyles}
      bounds={bounds}
      // initialCenter={initialCenter}
      mapTypeControl={false}
      onReady={handleMapReady}
    >
      {markers.map((marker, index) => (
        <Marker
          key={index}
          onClick={onMarkerClick}
          name={marker.name}
          position={marker.position}
        />
      ))}
      <InfoWindow
        marker={state?.activeMarker}
        visible={state?.showingInfoWindow}
        onClose={onClose}
      >
        <div>
          <h4>{state?.selectedPlace?.name}</h4>
        </div>
      </InfoWindow>
    </Map>
  );
};

export default GoogleApiWrapper({
  apiKey: GOOGLE_API,
})(MapContainer);
